// material-ui
import { Typography, Stack, Box } from '@mui/material'

import { useTheme } from '@mui/material/styles'

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

import iso from '../../assets/images/iso_tawa.svg'
import grupo_tawa from '../../assets/images/grupo_tawa.svg'

const AuthFooter = () => {
    const theme = useTheme()

    return (
        <Stack direction="row" justifyContent="space-between">
            <img src={iso} alt="Isotipos Tawa" width="80"></img>
            <Box sx={{
                display: 'flex'
            }}>
                <Typography variant="subtitle2" sx={{
                    color: theme.palette.primary.main
                }}>Desarrollado por</Typography>
                <img src={grupo_tawa} alt="Grupo tawa" width="80" style={{ marginLeft: 4 }}></img>
            </Box>
            <Box>
                <div style={{ width: 80 }}></div>
            </Box>
        </Stack>
    )
};

export default AuthFooter;
